/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const useMaintenanceWindowsConfigureStyles = makeStyles(theme => ({
  heading: {
    margin: '0 0 20px 0',
    color: theme.palette.primary.main,
    fontSize: '20px',
    lineHeight: '24px',
    fontWeight: 'bold',
  },
  hint: {
    fontSize: '12px',
    lineHeight: '16px',
    color: 'rgba(0,0,0,0.6)',
    paddingLeft: '5px',
  },
  error: {
    color: `${theme.palette.error.main} !important`,
  },
  dayPicker: {
    maxWidth: '200px !important',
  },
  timePicker: {
    marginTop: 0,
    maxWidth: '150px !important',
  },
}));
